import { getBackendUrl } from '../../../utils/config';

const constructUrl = (path: string) => `${getBackendUrl()}${path}`;

export { constructUrl };
